<!-- Bar Chart -->
<template>
	<ECharts :options="reformatOptions" style="width:100%; height:300px" />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import ChartHelper from '../../../../mixins/ChartHelper'

export default {
	name: 'SingleBar',
	props: {
		options: {
			type: Object,
			default: () => {
				return {}
			}
		},
		color: {
			type: Array,
			default: () => {
				return []
			}
		},
		showTitle: {
			type: Boolean,
			default: true
		},
		titleText: {
			type: String,
			default: ''
		},
		showLegend: {
			type: Boolean,
			default: true
		},
		xShowSplitLine: {
			type: Boolean,
			default: true
		},
		xAxisTick: {
			type: Boolean,
			default: true
		},
		xAxisLine: {
			type: Boolean,
			default: true
		},
		yShowSplitLine: {
			type: Boolean,
			default: true
		},
		yAxisTick: {
			type: Boolean,
			default: true
		},
		yAxisLabel: {
			type: Boolean,
			default: true
		},
		yAxisLine: {
			type: Boolean,
			default: true
		},
		dataset: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	components: {
		ECharts
	},
	mixins: [ChartHelper],
	computed: {
		reformatOptions() {
			/* eslint-disable */
			let series = []

			if (Object.keys(this.dataset).length > 0) {
				if ('source' in this.dataset && this.dataset.source.length > 0) {
					let i
					let barWidth = this.barWidthMultiple(
						this.totalData(this.dataset.source)
					)
					for (i = 0; i < this.dataset.source[0].length - 1; i++) {
						series.push({
							type: 'bar',
							barWidth
						})
					}
				}
			}

			/* eslint-enable */

			let dataChart = {
				grid: {
					left: '2%',
					right: '4%',
					bottom: '3%',
					top: '70',
					containLabel: true
				},
				legend: {
					// orient: 'vertical'
					top: 35,
					show: this.showLegend
				},
				title: {
					show: this.showTitle,
					text: this.titleText,
					textStyle: {
						fontSize: 24,
						height: 0
					}
				},
				tooltip: {
					show: true
				},
				color: this.color,
				dataset: this.dataset,
				xAxis: {
					type: 'category',
					boundaryGap: true,
					splitLine: {
						show: this.xShowSplitLine,
						lineStyle: {
							color: '#CCCCCC'
						}
					},
					axisTick: {
						show: this.xAxisTick
					},
					axisLine: {
						show: this.xAxisLine,
						lineStyle: {
							color: '#2C2C2C'
						}
					}
				},
				yAxis: {
					type: 'value',
					axisLabel: {
						show: this.yAxisLabel
					},
					axisTick: {
						show: this.yAxisTick
					},
					splitLine: {
						show: this.yShowSplitLine,
						lineStyle: {
							color: '#CCCCCC'
						}
					},
					axisLine: {
						show: this.yAxisLine,
						lineStyle: {
							color: '#2C2C2C'
						}
					}
				},
				series
			}

			return dataChart
		}
	}
}
</script>
